<template>
    <v-container fluid >
        <Formulario :getParams="this.params"></Formulario>
    </v-container>
</template>

<script>
import Formulario from "./components/Formulario.vue";
import Auth from "@/services/auth";
export default {
    name: "AdministracionImpresionNuevo",
    data() {
        return {
            permisos: [],
            params: {
                unidad_operativa_id: null,
                // Agregados
                año: null,
                promocion: null
            }
        }
    },
    components: {
        Formulario
    },
    methods: {
        regresar() {
            this.$router.go(-1)
        }
    },
    created() {
        Auth.checkPermisos("/administracion/impresion").then((res) => {
            this.permisos = res;
            if (!this.permisos[2]) {
                this.regresar();
            }
        });
    }
}
</script>

<style>

</style>
